module.exports = __webpack_public_path__ + "img/body.0b90540e.png";